module.exports = __webpack_public_path__ + "img/exam.430423f3.jpg";